// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"

// import required modules
import styled from "@emotion/styled"
import colors from "theme/colors"
import { CircleImage, Desktop, NewText, TitleWithLine } from "ui"

import { IconButton } from "@mui/material"
import { LeftArrowShort, RightArrowShort } from "ui/icons"

import { Navigation, Pagination } from "swiper/modules"
import { useIsDesktop } from "ui"
import { extractProperty } from "utils"

const StyledSwipContainer = styled.div`
  background: ${colors.white};
  box-shadow: 0px 16px 32px 0px rgba(17, 24, 39, 0.2);
  overflow: hidden;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  p {
    margin: 0px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 18px 0;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 28px 0;
  }
`

const StyledImage = styled.div`
  padding: 0 28px;
  display: flex;
  justify-content: start;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 20px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 28px;
  }
`
const StyledSwiperSlide = styled(SwiperSlide)`
  box-sizing: border-box;
  width: 315px !important;
  height: 555px !important;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 233px !important;
    height: 512px !important;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    width: 350px !important;
    height: 616px !important;
  }
`
const StyledSwapperDiv = styled.div`
  position: relative;
  margin-top: 24px;

  .swiper-pagination {
    top: unset;
    bottom: 0px;
    height: 2px;
    width: 70%;
    left: 0px;
    ${(props) => props.theme.breakpoints.down("sm")} {
      display: none;
    }
    .swiper-pagination-progressbar-fill {
      background: ${colors.black};
    }
  }
  .swiper-slide {
    height: auto;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 30px;
  }
`

const StyledArrowWrapper = styled.div`
  position: absolute;
  right: 0px;
  bottom: -18px;
  z-index: 2;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  margin-top: 12px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 13px;
    padding: 0 18px;
    /* height: 400px; */
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 28px;
    margin-top: 20px;
  }
`

const StyledIconButton = styled(IconButton)`
:focus-visible{
  border:1px solid gray;
}
`

const TextWrapperBlue = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
  }
`

const StyledRichTextFirst = styled.div`
  h4 {
    margin: 0;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: black;
  }
  p {
    color: black;
    padding-top: 8px;
    padding-bottom: 10px;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    h4 {
      font-size: 12px;
      line-height: 16px;
    }
    p {
      font-size: 12px;
      line-height: 18px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    h4 {
      font-size: 18px;
      line-height: 24px;
    }
    p {
      padding-top: 12px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`

const StyledRichText = styled.div`
  p {
    margin: 0;
    color: black;
    font-size: 14px;
    line-height: 20px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    p {
      font-size: 12px;
      line-height: 18px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
`

const SwiperWrapper = styled.div`
  background: rgba(232, 236, 240, 1);
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 146px;
    padding-right: 146px;
    padding-top: 80px;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 220px;
    padding-right: 220px;
  }
`

export default function SwiperPazoma({ data }: { data: any }) {
  const isDesktop = useIsDesktop()

  const carouselInnerItems = extractProperty(data, "carouselInnerItems")
  const title = extractProperty(data, "title")

  return (
    <SwiperWrapper>
      <TitleWithLine
        title={title}
        titleFontSize={isDesktop ? 64 : 32}
        titleColor={colors.black}
      />
      <StyledSwapperDiv>
        <Swiper
          key={1}
          style={{ paddingTop: 0, paddingBottom: isDesktop ? "40px" : "" }}
          modules={[Pagination, Navigation]}
          slidesPerView={"auto"}
          navigation={{ nextEl: ".arrow-left", prevEl: ".arrow-right" }}
          pagination={{
            type: "progressbar",
          }}
          spaceBetween={18}
        >
          {carouselInnerItems.map((block: any, index: any) => {
            // Extract the listText, imageUrl, and link properties from the block object
            const carouselImage = extractProperty(block, "carouselImage")
            const carouselTitle = extractProperty(block, "carouselTitle")
            const carouselTopText = extractProperty(block, "carouselTopText")
            const carouselInnerContent = extractProperty(
              block,
              "carouselInnerContent",
            )
            return (
              <StyledSwiperSlide key={index}>
                <StyledSwipContainer>
                  <StyledImage>
                    <CircleImage
                      width={"140px"}
                      height={"140px"}
                      src={carouselImage}
                      priority={true}
                    />
                  </StyledImage>
                  <TextWrapper>
                    <NewText
                      component="h3"
                      largeDesktopFontSize={24}
                      largeDesktopLineHeight="33.6px"
                      desktopLineHeight="22.4px"
                      desktopFontWeight="500"
                      color={colors.black}
                      desktopFontSize={16}
                      mobileFontSize={24}
                      mobileLineHeight={"33.6px"}
                    >
                      {carouselTitle}
                    </NewText>
                    <StyledRichTextFirst
                      dangerouslySetInnerHTML={{
                        __html: carouselTopText
                          .replace("<p> </p>", "")
                          .replace("h3", "p"),
                      }}
                    />
                    {carouselInnerContent.map((content: any, ind: number) => {
                      const contentTitle = extractProperty(
                        content,
                        "conetntTitle",
                      )
                      const innerText = extractProperty(content, "innerText")
                      return (
                        <TextWrapperBlue key={ind.toString()}>
                          <NewText
                            component="h4"
                            desktopFontSize={12}
                            largeDesktopFontSize={16}
                            largeDesktopLineHeight="24px"
                            desktopLineHeight="18px"
                            mobileFontSize={16}
                            mobileLineHeight={"24px"}
                            desktopFontWeight="500"
                            color={colors.blue}
                          >
                            {contentTitle}
                          </NewText>
                          <StyledRichText
                            dangerouslySetInnerHTML={{ __html: innerText }}
                          />
                        </TextWrapperBlue>
                      )
                    })}
                  </TextWrapper>
                </StyledSwipContainer>
              </StyledSwiperSlide>
            )
          })}
        </Swiper>
        <Desktop>
          <StyledArrowWrapper>
            <StyledIconButton
              disableRipple
              className="arrow-right arrow"
              aria-label="לשירות הקודם"
            >
              <RightArrowShort />
            </StyledIconButton>
            <StyledIconButton
              disableRipple
              className="arrow-left arrow" aria-label="לשירות הבא">
              <LeftArrowShort />
            </StyledIconButton>
          </StyledArrowWrapper>
        </Desktop>
      </StyledSwapperDiv>
    </SwiperWrapper>
  )
}
